export default __webpack_public_path__ + "static/media/80.c9e0db48.png";